export namespace IZendeskArticle {
  /**
   * Return an instance of IZendeskArticle with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IZendeskArticle>): IZendeskArticle =>
    ({
      label_names: [],
      ...(partial ?? {}),
    } as IZendeskArticle);
}

export interface IZendeskArticle {
  id: number | undefined;
  author_id: number | undefined;
  locale: string | undefined;
  name: string | undefined;
  title: string | undefined;
  body: string | undefined;
  html_url: string | undefined;
  url: string | undefined;
  created_at: string | undefined;
  edited_at: string | undefined;
  updated_at: string | undefined;
  comments_disabled: boolean | undefined;
  draft: boolean | undefined;
  label_names: Array<string>;
  outdated: boolean | undefined;
  user_segment_id: number | undefined;
  permission_group_id: number | undefined;
  position: number | undefined;
  promoted: boolean | undefined;
  result_type: string | undefined;
  section_id: number | undefined;
  snippet: string | undefined;
  source_locale: string | undefined;
  vote_count: number | undefined;
  vote_sum: number | undefined;
}
